<template>
    <div id="pageDashboard">
        <v-dialog max-width="450px" v-model="dialog" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-form ref="formUser" data-vv-scope="formUser" lazy-validation>
                    <v-card-text class="pt-0">
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex md6 xs12>
                                    <v-text-field
                                        :error-messages="errors.collect('formUser.first_name')"
                                        data-vv-name="first_name"
                                        label="First Name"
                                        v-model="editedItem.first_name"
                                        v-validate="{required: true, max:50}"
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md6 xs12>
                                    <v-text-field
                                        :error-messages="errors.collect('formUser.last_name')"
                                        data-vv-name="last_name"
                                        label="Last Name"
                                        v-model="editedItem.last_name"
                                        v-validate="'required|max:50'"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md6 xs12>
                                    <v-text-field
                                            :error-messages="errors.collect('formUser.email')"
                                            data-vv-delay="500"
                                            data-vv-name="email"
                                            label="Email"
                                            v-if="editedIndex < 0"
                                            v-model="editedItem.email"
                                            v-validate="{required: true, regex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/ ,max:100, unique: true}"
                                    >
                                        <v-fade-transition leave-absolute slot="append">
                                            <v-progress-circular color="info" indeterminate size="24" v-if="validating"></v-progress-circular>
                                            <!--  <v-icon color="error" v-else-if="errors.first('email')">close</v-icon>
                                            <v-icon color="success" v-else>check</v-icon>-->
                                        </v-fade-transition>
                                    </v-text-field>
                                    <v-text-field
                                        :disabled="true"
                                        label="Email"
                                        v-if="editedIndex >= 0"
                                        v-model="editedItem.email"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md6 xs12>
                                    <v-text-field
                                        :error-messages="errors.collect('formUser.new_password')"
                                        data-vv-name="new_password"
                                        label="Password"
                                        type="password"
                                        v-if="editedIndex < 0"
                                        v-model="editedItem.new_password"
                                        v-validate="'required|max:50|min:6'"
                                    ></v-text-field>
                                    <v-text-field
                                        :error-messages="errors.collect('formUser.new_password')"
                                        data-vv-name="new_password"
                                        label="New Password"
                                        type="password"
                                        v-if="editedIndex >= 0"
                                        v-model="editedItem.new_password"
                                        v-validate="'max:50|min:6'"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md6 xs12>
                                    <v-select
                                        :error-messages="errors.collect('formUser.user_type')"
                                        :items="currentRoles"
                                        :menu-props="{ maxHeight: '400' }"
                                        data-vv-name="user_type"
                                        label="Select role"
                                        persistent-hint
                                        v-model="editedItem.user_type"
                                        v-validate="'required'"
                                    ></v-select>
                                </v-flex>
                                <v-flex md6 xs12>
                                    <v-text-field
                                        :rules="[rules.required, rules.validPhoneNumber]"
                                        data-vv-name="phone"
                                        label="Phone"
                                        v-model="editedItem.phone"
                                        v-validate="'required'"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md5 offset-md1 xs12>
                                    <v-switch
                                        :label="editedItem.active ? 'Active': 'Disable'"
                                        v-model="editedItem.active"
                                        color="primary"
                                    ></v-switch>
                                </v-flex>
                                <v-flex md5 offset-md1 xs12>
                                    <v-switch
                                        :label="editedItem.isBlock ? 'Blocked' : 'Not Blocked'"
                                        v-model="editedItem.isBlock"
                                        color="error"
                                        :disabled="!isSuperAdmin"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialogConfirm = true" style="width: 85px">Cancel</v-btn>
                        <v-btn @click="save" color="primary" style="width: 85px">{{textBtn}}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog max-width="450px" v-model="dialogConfirm" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Alert</span>
                </v-card-title>
                <v-card-text>{{ title2 }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
                    <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-toolbar class="top-content" flat>
            <v-toolbar-title class="title-box">
                <span class="title">Users</span>
                <v-text-field
                    v-model="search"
                    placeholder="Search..."
                    prepend-inner-icon="search"
                    hide-details
                    clearable
                    solo
                    flat
                    class="search-input"
                    @input="searchUser"
                    @click:clear="clearSearch"
                ></v-text-field>
                <div class="list-option">
                    <v-checkbox
                            v-model="checkbox1"
                            hide-details
                            label="Active"
                    ></v-checkbox>
                    <v-checkbox
                            v-model="checkbox2"
                            hide-details
                            label="Disabled"
                    ></v-checkbox>
                    <v-checkbox
                            v-model="checkboxBlocked"
                            hide-details
                            label="Blocked"
                            color="error"
                    ></v-checkbox>
                </div>
            </v-toolbar-title>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="moduleData"
            :loading="loading"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1 list-user"
            item-key="name"
        >
            <template v-slot:headers="props">
                <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="['column', !(typeof header.sortable === 'boolean' && !header.sortable) ? 'sortable' : '', header.align ? header.align : 'text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                        @click="changeSort(header)"
                >
                    {{ header.text }}
                    <v-icon small v-if="!(typeof header.sortable === 'boolean' && !header.sortable)">arrow_upward</v-icon>
                </th>
            </template>
            <template slot="items" slot-scope="props">
                <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td class="text-xs-left">{{ props.item.first_name + " " + props.item.last_name}}</td>
                    <td class="text-xs-left">{{props.item.email }}</td>
                    <td class="text-xs-left">{{ showRoleUserLabel(props.item.user_type) }}</td>
                    <td class="text-xs-center">{{ props.item.active ? "Active" : 'Disable' }}</td>
                    <td class="text-xs-center">
                        <v-chip
                            v-if="props.item.isBlock"
                            small
                            color="error"
                            text-color="white"
                        >Blocked</v-chip>
                        <v-chip
                            v-else
                            small
                            color="success"
                            text-color="white"
                        >Normal</v-chip>
                    </td>
                    <td class="text-xs-center">
                        <v-icon @click="editItem(props.item)" class="mr-2" small v-if="(userInfo.user_type === 3|| (props.item.user_type !== 3 &&  props.item.user_type !== 4 ))">edit</v-icon>
                    </td>
                </tr>
            </template>
            <!--<template v-slot:footer>
                <td :colspan="headers.length" class="text-xs-center">
                    <v-btn @click="dialog =true" color="primary">Add</v-btn>
                </td>
            </template>-->
            <template v-slot:actions-prepend>
                <div class="actions-list">
                    <v-btn @click="addUser" color="primary">Add</v-btn>
                </div>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import UserService from "../services/user.service.js";
import { Validator } from "vee-validate";
import { isEmpty } from "lodash";
import { setTimeout } from "timers";
import configs from "../config/config";
export default {
    inject: ["$validator"],
    metaInfo() {
        return {
            title: "Manage user"
        };
    },
    data: () => ({
        dialogConfirm: false,
        pagination: {
            rowsPerPage: 10,
            page: 1
        },
        dialog: false,
        search: "",
        editedIndex: -1,
        userService: new UserService(),
        editedItem: {
            first_name: null,
            last_name: "",
            email: "",
            password: "",
            new_password: "",
            user_type: "",
            phone: "",
            active: true
        },
        sortBy: "",
        actionSearch: false,
        loading: false,
        id: "",
        validating: false,
        userTypes: [
            {
                text: "Technical Member",
                value: 1
            },
            {
                text: "Technical Leader",
                value: 2
            }
        ],
        selected: [],
        headers: [
            {
                text: "Full Name",
                value: "first_name"
            },
            { text: "Email", value: "email" },
            { text: "Role", value: "user_type" },
            { text: "Status", value: "active", align: "text-xs-center" },
            { text: "Blocked", value: "isBlock", sortable: false, align: "text-xs-center" },
            { text: "Action", sortable: false, align: "text-xs-center" }
        ],
        moduleData: [],
        rowsPerPageItems: [10, 20, 50],
        dictionary: {
            custom: {
                "first_name": {
                    required: () => "The first name field is required.",
                    max: () => "Max 50 characters"
                },
                "last_name": {
                    required: () => "The last name field is required.",
                    max: () => "Max 50 characters"
                },
                "user_type": {
                    required: () => "The role field is required."
                },
                "new_password": {
                    required: () => "The password field is required.",
                    max: () => "Max 50 characters",
                    min: () => "Min 6 characters"
                },
                "email": {
                    required: () => "The email field is required.",
                    max: () => "Max 100 characters"
                }
            }
        },
        rules: {
            required: (v) => (v && v.trim().length > 0) || "It is required field",
            validPhoneNumber: value => {
                const phoneRegex = /^0[1-9]\d{8}$/;
                return phoneRegex.test(value) || 'The phone number field must be 10 digits.';
            },
        },
        checkbox1: false,
        checkbox2: false,
        checkboxBlocked: false,
        active: null,
        isBlock: null
    }),
    mounted() {
        const isUnique = value => {
            this.validating = true;
            return this.userService.checkAcc(value).then(res => {
                this.validating = false;
                return {
                    valid: (res && !res.is_exists),
                    data: { message: "Username has been already existed" }
                };
            });
        };
        this.$validator.localize("en", this.dictionary);
        Validator.extend("unique", {
            validate: isUnique,
            getMessage: (field, params, data) => data.message
        });
        if (this.userInfo && this.userInfo.user_type !== configs.isAdmin && this.userInfo.user_type !== configs.isSuperAdmin) {
            this.$router.push('/dashboard');
        }
    },
    created() {

    },
    watch: {
        pagination: {
            handler() {
                this.getData();
            },
            deep: true
        },
        userInfo() {
            if (this.userInfo && this.userInfo.user_type !== configs.isAdmin && this.userInfo.user_type !== configs.isSuperAdmin) {
                this.$router.push('/dashboard');
            }
        },
        checkbox1() {
            this.filterUser();
        },
        checkbox2() {
            this.filterUser();
        },
        checkboxBlocked() {
            this.filterUser();
        }
    },
    computed: {
        title2() {
            return this.editedIndex === -1 ? "Are you sure to cancel the new creation?" : "Are you sure to cancel the changes?";
        },
        formTitle() {
            return this.editedIndex === -1 ? "Add User" : "Edit User";
        },
        textBtn() {
            return this.editedIndex === -1 ? "Done" : "Save";
        },
        userInfo() {
            return this.$store.getters["auth/currentUser"];
        },
        isSuperAdmin() {
            return this.userInfo && this.userInfo.user_type === configs.isSuperAdmin;
        },
        currentRoles() {
          const permissions = this.$store.getters["auth/currentUser"];
          if (permissions && permissions.user_type === configs.isSuperAdmin) {
            const _userTypes = this.userTypes;
            return [{
              text: "Admin",
              value: 4
            }, ..._userTypes];
          }
          return this.userTypes;
        }
    },
    methods: {
        changeSort (data) {
            if (typeof data.sortable === 'boolean' && !data.sortable) return;
            const column = data.value;
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false
            }
            this.pagination.page = 1;
        },
        searchUser() {
            if (this.actionSearch) return;
            this.actionSearch = true;
            setTimeout(() => {
                this.pagination.page = 1;
                this.getData();
                this.actionSearch = false;
            }, 800);
        },
        clearSearch() {
            this.search = '';
            this.pagination.page = 1;
            this.getData();
        },
        close() {
            this.dialog = false;
            this.dialogConfirm = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, {
                    first_name: "",
                    last_name: "",
                    email: "",
                    password: "",
                    new_password: "",
                    user_type: "",
                    phone: "",
                    active: true
                });
                this.editedIndex = -1;
                this.$validator.reset();
            }, 500);

        },
        showRoleUserLabel(data) {
            if (data === 4 || data === 3) return "Admin";
            else if (data === 2) return "Technical Leader";
            else return "Technical Member";
        },
        getData() {
            this.loading = true;
            let params = {
                page: this.pagination.page,
                limit: this.pagination.rowsPerPage,
                active: this.active,
                ...(this.isBlock !== null && { isBlock: this.isBlock })
            };
            if (!isEmpty(this.search)) params.search = this.search;
            if (this.pagination.sortBy) {
                params.sort =
                    (this.pagination.descending ? "-" : "") +
                    this.pagination.sortBy;
            }
            this.userService.getList(params).then(res => {
                this.moduleData = res.docs;
                this.loading = false;
                this.pagination.totalItems = res.total;
            });
        },
        editItem(item) {
            this.editedIndex = this.moduleData.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.id = this.moduleData[this.editedIndex].id;
            this.dialog = true;
        },
        addUser() {
            this.dialog = true;
            // this.editedItem = {};
        },
        save() {
            this.$validator.validate('formUser.*').then(result => {
                if (result) {
                    if (this.editedIndex === -1) {
                        this.editedItem.password = this.editedItem.new_password;
                        this.userService.add(this.editedItem).then(res => {
                            if (res.data && res.data.statusCode === 200) {
                                this.close();
                                this.getData();
                            } else {
                                this.message = res.data.message;
                            }
                        });
                    } else {
                        if (!isEmpty(this.editedItem.new_password)) {
                            this.editedItem.password = this.editedItem.new_password;
                            delete this.editedItem.new_password;
                        }
                        this.userService
                            .edit(this.editedItem, this.id)
                            .then(res => {
                                if (res.data) {
                                    this.close();
                                    this.getData();
                                }
                            });
                    }
                }
            });
        },
        filterUser() {
            if (this.checkbox1) {
                if (this.checkbox2) {
                    this.active = null;
                } else {
                    this.active = true;
                }
            } else {
                if (this.checkbox2) {
                    this.active = false;
                } else {
                    this.active = null;
                }
            }
            this.isBlock = this.checkboxBlocked ? true : null;
            this.getData();
            //console.log(this.active);
        }
    }
};
</script>
<style>
    #pageDashboard .v-datatable__actions {
        position: relative;
    }
    @media screen and (min-width: 1080px){
      .actions-list {
        left: calc(50% - 55px);
      }
    }
    .actions-list {
        position: absolute;
        top: 5px;
    }
    .v-card__title {
        font-size: 18px;
        font-weight: bold;
        background-color: #f5f5f5;
    }
    .v-card__actions {
        padding: 15px 10px;
    }
    .top-content {
        background-color: #f5f5f5;
        color: rgba(0,0,0,0.87);
    }
    .v-toolbar__title.title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 60px;
        width: 100%;
    }
    .search-input {
        max-width: 340px;
        margin: 0 16px;
    }
    .search-input .v-input__slot {
        border: 1px solid #e0e0e0 !important;
        border-radius: 8px !important;
    }
    .list-option {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .list-option .v-input--selection-controls {
        margin-left: 20px;
    }
    .list-option .v-input--selection-controls .theme--light.v-label {
        color: rgba(0, 0, 0, 0.87);
        font-size: 14px;
    }
</style>
